export default __webpack_public_path__ + "static/rocket-a53842e0d76caecee994466857fe6c51.svg";